(function ($) {
  const $video_preview_content = $(".video-preview__content");
  const $video_preview_button = $(".video-preview__button");
  const mobile_check = $(".is-mobile");

  if ($video_preview_content.length) {
    $video_preview_content.slick({
      fade: true,
      arrows: false,
      swipe: false,
      swipeToSlide: false,
      infinite: false,
      touchMove: false,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: false,
    });
  }

  $(document).on("click", $video_preview_button, function (event) {
    var button = $(event.target);

    if ( button.hasClass('video-preview__button') ) {

      var slide = button.data("preview-slide");

      var buttons = $(".video-preview__button");
      buttons.each(function () {
        $(this).removeClass("active");
      });

      button.addClass("active");
      $video_preview_content.slick("slickGoTo", slide - 1);
    }
  });

  const $video_slider = $(".video-slider");
  const $video_slider_controls = $('.slider-controls[data-for="video-slider"]');
  const $prev = $video_slider_controls.find(".slider-controls__prev");
  const $next = $video_slider_controls.find(".slider-controls__next");

  if ($video_slider.length) {
    $video_slider.slick({
      dots: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      nextArrow: $next,
      prevArrow: $prev,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
          },
        },
      ],
    });
  }

  // period carousel

  const $period_carousel = $(".period-carousel");
  const $pc_controls = $('.slider-controls[data-for="period-carousel"]');
  const $pPrev = $pc_controls.find(".slider-controls__prev");
  const $pNext = $pc_controls.find(".slider-controls__next");
  var slickEnabled = false;

  $(window).on("load resize", function () {
    var display = $period_carousel.css("display");

    if (display == "block" && slickEnabled == false) {
      $period_carousel.slick({
        dots: false,
        slidesToScroll: 1,
        slidesToShow: 2,
        infinite: false,
        nextArrow: $pNext,
        prevArrow: $pPrev,
        centerPadding: "0px",
        mobileFirst: true,
        centerMode: true,
        responsive: [
          {
            breakpoint: 767,
            settings: "unslick",
          },
        ],
      });
      slickEnabled = true;
    } else if (display == "flex" && slickEnabled == true) {
      slickEnabled = false;
    }
  });

  // video preview buttons

  const $preview_buttons = $(".video-preview__buttons");
  var buttonSlickEnabled = false;

  $(window).on("load resize", function () {
    if (isMobile() && buttonSlickEnabled == false) {
      if ($preview_buttons.length) {
        $preview_buttons.slick({
          arrows: false,
          dots: false,
          slidesToScroll: 1,
          slidesToShow: 1,
          infinite: false,
          mobileFirst: true,
          centerMode: true,
          responsive: [
            {
              breakpoint: 767,
              settings: "unslick",
            },
          ],
        });

        buttonSlickEnabled = true;
      }
    } else if (!isMobile() && buttonSlickEnabled == true) {
      buttonSlickEnabled = false;
    }
  });

  function isMobile() {
    var display = mobile_check.css("display");
    if (display == "block") {
      return true;
    } else {
      return false;
    }
  }

  // Lightbox gallery

  const $lightbox_gal = $(".lightbox-gallery");
  const $lightbox_gal_prev = $lightbox_gal.find(".slider-controls__prev");
  const $lightbox_gal_next = $lightbox_gal.find(".slider-controls__next");
  const $lightbox_slider = $lightbox_gal.find(".lightbox-gallery__slider");

  if ($lightbox_slider.length) {
    $lightbox_slider.slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      prevArrow: $lightbox_gal_prev,
      nextArrow: $lightbox_gal_next,
      infinite: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 330,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  var $lightbox = $(".lightbox-gallery__item");

  $lightbox_slider.on("breakpoint", function (event) {
    $lightbox = $(".lightbox-gallery__item");
    setLightbox();
  });

  setLightbox();

  function setLightbox() {
    $lightbox = $(".lightbox-gallery__item");

    $lightbox.featherlight({
      afterContent: function () {
        var caption = this.$currentTarget.data("caption");
        var content = this.$instance.find(".featherlight-content");
        if (caption.length) {
          content.append('<p class="caption">' + caption + "</p>");
        }
      },
    });
  }
})(jQuery);
